
define('text!templates/widgets/dataGridCells/selectCell.html',[],function () { return '<select data-bind="\n        options: $data.options,\n        value: $data.val,\n        valueUpdate: &apos;afterkeyup&apos;\n    ">\n</select>';});

